<div class="top-section">
  <h6 class="heading mb-0">{{ ss.t('meo_ai_preferences_title') }}</h6>
  <div class="flex items-center gap-6">
    <app-svg name="plusThin" role="button" (click)="startAdd()" [color]="ss.theme().color12"
      class="header-icon"
      [attr.aria-label]="ss.t('meo_ai_preferences_add')"></app-svg>
    <app-svg name="close" role="button" (click)="close()"></app-svg>
  </div>
</div>

<div class="memory-content hide-scrollbar" (click)="onContentClick($event)">
  @if (isLoading()) {
    <div class="loading-state">
      <span class="loading-text">...</span>
    </div>
  } @else if (facts().length === 0 && !isAdding) {
    <div class="empty-state">
      <app-svg [name]="brandLogo" height="48" [color]="ss.theme().color35"></app-svg>
      <p class="empty-text">{{ ss.t('meo_ai_preferences_empty') }}</p>
    </div>
  } @else {
    <div class="facts-list">
      <!-- Add new memory -->
      @if (isAdding) {
        <div class="fact-item editing ri-px-4 ri-py-3">
          <textarea
            class="memory-input text-16-400 color-8"
            [(ngModel)]="addText"
            (keydown)="onAddKeydown($event)"
            [placeholder]="ss.t('meo_ai_preferences_add_placeholder')"
            rows="1"
            cdkTextareaAutosize
            [cdkAutosizeMinRows]="1"
          ></textarea>
          <div class="action-row">
            <button class="action-btn" (click)="saveAdd()"
              [attr.aria-label]="ss.t('common_save')">
              <app-svg name="tick" height="18" width="18" [color]="ss.theme().color35"></app-svg>
            </button>
            <button class="action-btn" (click)="cancelAdd()"
              [attr.aria-label]="ss.t('common_buttonCancel')">
              <app-svg name="trash" height="18" width="18" [color]="ss.theme().color11"></app-svg>
            </button>
          </div>
        </div>
      }

      @for (fact of facts(); track fact.id) {
        <div class="fact-item ri-px-4 ri-py-3" [class.editing]="editingFactId === fact.id">
          @if (editingFactId === fact.id) {
            <!-- Edit mode -->
            <textarea
              class="memory-input text-16-400 color-8"
              [(ngModel)]="editText"
              (keydown)="onEditKeydown($event, fact)"
              (blur)="onEditBlur(fact)"
              rows="1"
              cdkTextareaAutosize
              [cdkAutosizeMinRows]="1"
            ></textarea>
            <div class="action-row">
              <button class="action-btn" (mousedown)="$event.preventDefault(); saveEdit(fact)"
                [attr.aria-label]="ss.t('common_save')">
                <app-svg name="tick" height="18" width="18" [color]="ss.theme().color35"></app-svg>
              </button>
              <button class="action-btn" (mousedown)="$event.preventDefault(); deleteFact(fact)"
                [attr.aria-label]="ss.t('common_delete')">
                <app-svg name="trash" height="18" width="18" [color]="ss.theme().color11"></app-svg>
              </button>
            </div>
          } @else {
            <!-- Display mode -->
            <span class="fact-text text-16-400 color-8" role="button" tabindex="0"
              (click)="startEdit(fact)"
              (keydown.enter)="startEdit(fact)">{{ fact.fact }}</span>
          }
        </div>
      }
    </div>
  }
</div>
